export default __webpack_public_path__ + "static/IntroOptimized-c0e7e384923dc7180cf914afbcf60c4a.mp4";